import { create } from 'zustand';
import { PgProduct } from '../shared/types';

interface NetworkChartStore {
  onCreateNodeGraph: ((productId: number, productData?: PgProduct) => void) | null;
  setOnCreateNodeGraph: (callback: ((productId: number, productData?: PgProduct) => void) | null) => void;
  onOpenNetworkWithIOC: ((value: string) => void) | null;
  setOnOpenNetworkWithIOC: (callback: ((value: string) => void) | null) => void;
  pendingProductData: PgProduct | null;
  setPendingProductData: (productData: PgProduct | null) => void;
}

export const useNetworkChartStore = create<NetworkChartStore>((set) => ({
  onCreateNodeGraph: null,
  setOnCreateNodeGraph: (callback) => set({ onCreateNodeGraph: callback }),
  onOpenNetworkWithIOC: null,
  setOnOpenNetworkWithIOC: (callback) => set({ onOpenNetworkWithIOC: callback }),
  pendingProductData: null,
  setPendingProductData: (productData) => set({ pendingProductData: productData }),
}));

